import { commonAxios } from "../utils/AxiosSettings";

export const getOfflineCasesData = async (url) => {
    const res = await commonAxios.get(url);
    return res;
};

export const getOfflineCaseData = async (id) => {
    const res = await commonAxios.get(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/OfflineCase/${id}`
    );
    return res;
};

export const uploadOfflineCase = async (data) => {
    const res = await commonAxios.post(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/OfflineCase/`,
        data
    );
    return res;
};

export const addWorkerCommittee = async (data) => {
    const res = await commonAxios.post(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/WorkerCommittee/`,
        data
    );
    return res;
};
